module.exports = __webpack_public_path__ + "img/delete.dedef38e.svg";